export enum BorderRadiusToken {
  none = 'none',
  nano = '0.2rem',
  micro = '0.4rem',
  small = '0.6rem',
  medium = '0.8rem',
  large = '1rem',
  huge = '1.2rem',
  xHuge = '1.4rem',
  giant = '1.6rem',
  display = '2.4rem',
  pill = '50%',
}
export default BorderRadiusToken

export type TRadius =
  | 'none'
  | 'nano'
  | 'micro'
  | 'small'
  | 'medium'
  | 'large'
  | 'huge'
  | 'xHuge'
  | 'giant'
  | 'display'
  | 'pill'
